import reducer from './reducers';

import * as settingsSelectors from './selectors';
import * as settingsActions from './actions';
import * as settingsOperations from './operations';
import { SettingsState } from './types';

export { settingsSelectors, settingsActions, settingsOperations };
export type { SettingsState };

export default reducer;
